import { render, staticRenderFns } from "./MovieContents.vue?vue&type=template&id=3234b59a&"
import script from "./MovieContents.vue?vue&type=script&lang=ts&"
export * from "./MovieContents.vue?vue&type=script&lang=ts&"
import style0 from "./MovieContents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
